import { CrmSelect, crmSelectFieldWrapperClass } from "@/components/crm/CrmListChevron";
import type { CrmOrgUserRow } from "@/lib/crmOwnerUsers";
import { crmOrgUserDisplayName } from "@/lib/crmOwnerUsers";
import { cn } from "@/lib/utils";

type CrmOwnerSelectProps = {
  value: string;
  onChange: (ownerId: string) => void;
  users: CrmOrgUserRow[];
  loading?: boolean;
  disabled?: boolean;
  className?: string;
  id?: string;
};

export function CrmOwnerSelect({
  value,
  onChange,
  users,
  loading,
  disabled,
  className,
  id,
}: CrmOwnerSelectProps) {
  const sorted = [...users].sort((a, b) =>
    crmOrgUserDisplayName(a).localeCompare(crmOrgUserDisplayName(b), undefined, {
      sensitivity: "base",
    }),
  );

  return (
    <CrmSelect
      id={id}
      value={value}
      disabled={disabled || loading}
      onChange={(e) => onChange(e.target.value)}
      wrapperClassName={cn("mt-1", crmSelectFieldWrapperClass, className)}
      className="bg-transparent py-2 pl-3"
    >
      {loading ? <option value={value}>Loading people…</option> : null}
      {!loading && !value ? <option value="">Select owner…</option> : null}
      {!loading && value && !sorted.some((u) => u.id === value) ? (
        <option value={value}>{value}</option>
      ) : null}
      {sorted.map((user) => (
        <option key={user.id} value={user.id}>
          {crmOrgUserDisplayName(user)}
          {user.email && crmOrgUserDisplayName(user) !== user.email ? ` (${user.email})` : ""}
        </option>
      ))}
    </CrmSelect>
  );
}
